import * as Sentry from '@sentry/browser';

// TYPES
import { ERROR_FEEDBACK } from '../../types';

// UTILS
import findErrorUTL from '../../../utils/findErrorUTL';
import loggerUTL from '../../../utils/loggerUTL';

const feedbackGB = (errors, dispatch) => {
  loggerUTL('ERRORS...', errors);
  const inputError = {
    personalInformation: {},
    email: {},
    phone: {}
  };

  try {
    /* ============================================
                PERSONAL INFORMATION
    ============================================= */
    if (findErrorUTL(errors, 'firstName')) {
      inputError.personalInformation.firstName = `First name ${
        errors.find((item) => item.includes('firstName')).split(':')[1]
      }`;
    }
    if (findErrorUTL(errors, 'lastName')) {
      inputError.personalInformation.lastName = `Last name ${
        errors.find((item) => item.includes('lastName')).split(':')[1]
      }`;
    }

    
    /* ============================================
                    Phone No
    ============================================ */
    if (findErrorUTL(errors, 'phoneNo')) {
      inputError.phone.phoneNo = `Phone number should be ${
        errors.find((item) => item.includes('phoneNo')).split(':')[1]
      }`;
    }

    /* ============================================
                EMAIL
    ============================================= */
    if (findErrorUTL(errors, 'email')) {
      inputError.email.email = `Email ${
        errors.find((item) => item.includes('email')).split(':')[1]
      }`;
    }
  } catch(err) {
    Sentry.captureException(
      'FAILED TO PARES United Kingdom VALIDATION ERRORS...',
      JSON.stringify
    )(errors);
  }

  dispatch({
    type: ERROR_FEEDBACK,
    payload: inputError,
  });
};

export default feedbackGB;